import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useCreatePayment } from 'src/features/payments/api/useCreatePayment';
import { LIST_PAYMENTS_RESOURCE } from 'src/features/payments/api/useListPayments';
import { paymentsMessages } from 'src/features/payments/utils/messages';
import PaymentFormModal from 'src/features/payments/components/forms/PaymentFormModal';

interface CreatePaymentFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    children?: React.ReactNode;
}

function CreatePaymentFormModal<TData>({ className, semantics }: CreatePaymentFormModalProps<TData>) {
    const { formatMessage } = useIntl();

    const { mutate, isPending } = useCreatePayment({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_PAYMENTS_RESOURCE] });
            toast({
                title: formatMessage(paymentsMessages.createPaymentSuccess),
                description: formatMessage(paymentsMessages.createPaymentSuccessDescription),
            });
        },
    });

    return (
        <PaymentFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate(values, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(paymentsMessages.addPaymentSubtitle)}
        />
    );
}

export default CreatePaymentFormModal;
